import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {attachTransformChainLabel} from '../../utils/transformChainUtil.js';

export var TransformChainTestDialog = {

	show(options) {
		options = options || {};
		var initialInput = options.inputValue != null ? options.inputValue : '';
		var initialChain = options.chainValue != null ? options.chainValue : '';
		var dialogTitle = options.title || 'Transform chain tester';
		var onApply = options.onApply;

		var testWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: dialogTitle,
			icon: 'vaadin:tools',
			width: 640,
			height: 420,
			listeners: {
				ready: function () {
					testWin.show();

					var messagePanel = ElementUtil.create({
						tag: 'div',
						'class': 'regex-tester-message'
					});

					var outputField;

					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [
							messagePanel,
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'vaadin-text-field',
										itemid: 'testValue',
										name: 'testValue',
										label: 'Sample input',
										value: initialInput,
										colspan: 2,
										autocomplete: 'off'
									},
									{
										tag: 'vaadin-text-field',
										itemid: 'transformRaw',
										name: 'transformRaw',
										value: initialChain,
										required: true,
										colspan: 2,
										autocomplete: 'off',
										'helper-text': 'Comma, space, or semicolon separated (e.g. UPPER,TRIM_LEAD_ZEROS)',
										postinit: function (chainField) {
											attachTransformChainLabel(chainField, 'Transform chain');
										}
									},
									{
										tag: 'vaadin-text-field',
										itemid: 'output',
										name: 'output',
										label: 'Output',
										readonly: true,
										colspan: 2,
										postinit: function (field) {
											outputField = field;
										}
									},
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: buildActionButtons()
									}
								]
							}
						]
					});

					testWin.addToContentElement(formPanel);

					function buildActionButtons() {
						var buttons = [
							{
								itemid: 'testBtn',
								theme: 'primary',
								children: [
									ElementUtil.makeIcon('vaadin:play', ' Test')
								],
								listeners: {
									click: function () {
										runTest();
									}
								}
							}
						];

						if (onApply) {
							buttons.push({
								itemid: 'applyBtn',
								theme: 'success',
								style: 'margin-left: 10px;',
								children: [
									ElementUtil.makeIcon('vaadin:check', ' Apply chain')
								],
								listeners: {
									click: function () {
										var chainField = ElementUtil.query(formPanel, 'transformRaw');
										onApply(chainField.value);
										testWin.close();
									}
								}
							});
						}

						buttons.push({
							theme: 'tertiary',
							innerHTML: 'Close',
							style: 'margin-left: 10px;',
							listeners: {
								click: function () {
									testWin.close();
								}
							}
						});

						return buttons;
					}

					function runTest() {
						var data = formPanel.getData();
						messagePanel.classList.remove('regex-tester-error', 'regex-tester-matched', 'regex-tester-unmatched');
						messagePanel.innerHTML = '';

						if (!data.transformRaw || data.transformRaw.trim() === '') {
							messagePanel.classList.add('regex-tester-error');
							messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:close"></vaadin-icon> Transform chain is required.</b>';
							if (outputField) {
								outputField.value = '';
							}
							return;
						}

						var loadMask = formPanel.showLoading('Running...');
						Service.getApplicationService().testTransformChain({
							transformRaw: data.transformRaw,
							testValue: data.testValue
						}).then(function (results) {
							loadMask.remove();
							if (results.errorMessage) {
								messagePanel.classList.add('regex-tester-error');
								messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:close"></vaadin-icon> '
										+ results.errorMessage + '</b>';
								if (outputField) {
									outputField.value = '';
								}
							} else {
								messagePanel.classList.add('regex-tester-matched');
								messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:check-circle"></vaadin-icon> Done</b>';
								if (outputField) {
									outputField.value = results.result != null ? results.result : '';
								}
							}
						}).catch(function () {
							loadMask.remove();
							messagePanel.classList.add('regex-tester-error');
							messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:close"></vaadin-icon> Request failed.</b>';
						});
					}
				}
			}
		});
	}
};
